{
  "chart": {
    "header": "Chart"
  },
  "filter": {
    "placeholder": "All Documents"
  }
}
